class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.atcButton = null;
    this.sectionId = null;
    this.hasVariants = false;
    this.productFormSelector = null;
    this.visibility = 'both';
    this.hasSeenForm = false;
  }

  connectedCallback() {
    this.sectionId = this.getAttribute('data-section-id');
    const atcSelector = this.getAttribute('data-atc-button-selector');
    this.productFormSelector = this.getAttribute('data-product-form-selector');
    this.hasVariants = this.getAttribute('data-has-variants') === 'true';
    this.visibility = this.getAttribute('data-visibility') || 'both';
    this.isExpanded = false;
    
    this.handleVisibility();
    
    if (!atcSelector) {
      console.warn('ProductStickyBar: No ATC button selector provided');
      return;
    }

    this.atcButton = document.querySelector(atcSelector);
    if (!this.atcButton) {
      console.warn('ProductStickyBar: ATC button not found');
      return;
    }

    this.setupIntersectionObserver();
    this.setupSelectButton();
    this.setupToggle();
    this.setupFormSync();
    this.setupPriceSync();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  handleVisibility() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    
    if (this.visibility === 'desktop' && isMobile) {
      this.style.display = 'none';
      return;
    }
    
    if (this.visibility === 'mobile' && !isMobile) {
      this.style.display = 'none';
      return;
    }
    
    window.addEventListener('resize', () => {
      const isMobileNow = window.matchMedia('(max-width: 768px)').matches;
      
      if (this.visibility === 'desktop' && isMobileNow) {
        this.style.display = 'none';
      } else if (this.visibility === 'mobile' && !isMobileNow) {
        this.style.display = 'none';
      } else {
        this.style.display = '';
      }
    });
  }

  setupSelectButton() {
    if (!this.hasVariants) {
      return;
    }

    const selectButton = this.querySelector('.product-sticky-bar__select-variant[data-select-variant="true"]');
    if (!selectButton) {
      return;
    }

    selectButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.scrollToProductForm();
    });
  }

  scrollToProductForm() {
    const section = document.querySelector(`#Product--${this.sectionId}`);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  setupIntersectionObserver() {
    if (!this.atcButton || !window.IntersectionObserver) {
      return;
    }

    const checkInitialPosition = () => {
      const buttonRect = this.atcButton.getBoundingClientRect();
      const isInitiallyVisible = buttonRect.top >= 0 && buttonRect.top < window.innerHeight;
      
      if (isInitiallyVisible) {
        this.hasSeenForm = true;
      }
    };

    checkInitialPosition();

    const checkScrollPosition = () => {
      const buttonRect = this.atcButton.getBoundingClientRect();
      const buttonBottom = buttonRect.bottom;
      const scrollY = window.scrollY || window.pageYOffset;
      const buttonTopPosition = scrollY + buttonRect.top;
      
      const isInViewport = buttonRect.top >= 0 && buttonRect.top < window.innerHeight;
      
      const hasScrolledPast = buttonRect.top < 0;
      
      if (isInViewport) {
        this.hasSeenForm = true;
        this.classList.remove('is-visible');
      } else if (hasScrolledPast && this.hasSeenForm) {
        this.classList.add('is-visible');
      } else {
        this.classList.remove('is-visible');
      }
    };

    window.addEventListener('scroll', checkScrollPosition, { passive: true });
    
    checkScrollPosition();
  }

  setupToggle() {
    const toggleButton = this.querySelector('[data-toggle-expand]');
    if (!toggleButton) {
      return;
    }

    toggleButton.addEventListener('click', () => {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.classList.add('is-expanded');
      } else {
        this.classList.remove('is-expanded');
      }
    });
  }


  setupPriceSync() {
    const priceEl   = this.querySelector('[data-price-wrapper] [data-product-price]');
    const atcBtn    = this.querySelector('[data-add-to-cart]');
    const atcPrice  = this.querySelector('[data-atc-price]');
    const atcSuffix = this.querySelector('.btn__price-suffix');
    if (!priceEl || !atcBtn || !atcPrice || !atcSuffix) return;

    const sync = () => {
      const available = !atcBtn.disabled;
      atcSuffix.hidden = !available;
      if (available) atcPrice.textContent = priceEl.textContent.trim();
    };

    new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true, characterData: true });
    new MutationObserver(sync).observe(atcBtn, { attributes: true, attributeFilter: ['disabled'] });
  }

  setupFormSync() {
    const mainForm = document.querySelector(this.productFormSelector);
    if (!mainForm) {
      return;
    }

    const stickyForm = this.querySelector('.product-form');
    if (!stickyForm) {
      return;
    }

    const variantInput = mainForm.querySelector('input[name="id"]');
    if (variantInput) {
      const observer = new MutationObserver(() => {
        const stickyVariantInput = stickyForm.querySelector('input[name="id"]');
        if (stickyVariantInput && variantInput.value) {
          stickyVariantInput.value = variantInput.value;
        }
      });

      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      
      variantInput.addEventListener('change', () => {
        const stickyVariantInput = stickyForm.querySelector('input[name="id"]');
        if (stickyVariantInput && variantInput.value) {
          stickyVariantInput.value = variantInput.value;
        }
      });
    }

    const mainQuantityInput = mainForm.querySelector('input[name="quantity"]');
    const stickyQuantityInput = stickyForm.querySelector('input[name="quantity"]');
    
    if (mainQuantityInput && stickyQuantityInput) {
      mainQuantityInput.addEventListener('change', () => {
        stickyQuantityInput.value = mainQuantityInput.value;
      });
    }
  }
}

if (!customElements.get('product-sticky-bar')) {
  customElements.define('product-sticky-bar', ProductStickyBar);
}
